import { Box, Button, Flex, Heading } from '@chakra-ui/react';
import axios from 'axios';
import { useContext, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import UserContext from '../../context/userContext';
import './Login_Register_Styles.css';

function Register() {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [passwordCheck, setPasswordCheck] = useState();
  const [displayName, setDisplayName] = useState();
  const handleInputChanges_Email = e => {
    setEmail(e.target.value);
  };
  const handleInputChanges_Password = e => {
    setPassword(e.target.value);
  };
  const handleInputChanges_PasswordCheck = e => {
    setPasswordCheck(e.target.value);
  };
  const handleInputChanges_DisplayName = e => {
    setDisplayName(e.target.value);
  };

  const { setUserData } = useContext(UserContext);

  const submit = async e => {
    e.preventDefault();
    setEmail('');
    setPassword('');
    setPasswordCheck('');
    setDisplayName('');
    try {
      const newUser = { email, password, passwordCheck, displayName };
      await axios.post(
        'https://mern-stack-movies-app.herokuapp.com/consumers/register',
        newUser
      );
      const loginResponse = await axios.post(
        'https://mern-stack-movies-app.herokuapp.com/consumers/login',
        {
          email,
          password,
        }
      );
      setUserData({
        token: loginResponse.data.token,
        user: loginResponse.data.user,
      });
      localStorage.setItem('auth-token', loginResponse.data.token);
      const notify = () => toast.success('Register successful!');
      notify();
    } catch (err) {
      const notify = () => toast.error(<h3>Error! {err.response.data.msg}</h3>);
      notify();
      console.log('Error is=', err);
    }
  };

  return (
    <>
      <Toaster />
      <Box>
        <Flex mt={3} direction="row" wrap="wrap" justify="center">
          <Heading as="u">Register</Heading>
        </Flex>
      </Box>
      <Box mt={5} mb={5}>
        <Flex direction="row" wrap="wrap" justify="center">
          <form onSubmit={submit}>
            <label>Email: </label>
            <input
              type="email"
              value={email}
              onChange={handleInputChanges_Email}
              placeholder="Give email"
              required
              minlength="8"
              maxlength="30"
            />
            <label>Password: </label>
            <input
              type="password"
              value={password}
              onChange={handleInputChanges_Password}
              placeholder="Give password"
              required
              minlength="5"
              maxlength="15"
            />
            <input
              type="password"
              value={passwordCheck}
              onChange={handleInputChanges_PasswordCheck}
              placeholder="Confirm password"
              required
              minlength="5"
              maxlength="15"
            />
            <label>Display name </label>
            <input
              type="text"
              value={displayName}
              onChange={handleInputChanges_DisplayName}
              placeholder="Give Display Name"
              required
              minlength="3"
              maxlength="15"
            />
            <Button
              type="submit"
              ml={3}
              colorScheme="messenger"
              size="lg"
              mt={3}
            >
              REGISTER
            </Button>
          </form>
        </Flex>
      </Box>
    </>
  );
}

export default Register;
